import { createContext } from 'react'

const LocationContext = createContext({
    locationId: null,
    locationName: null,
})

export default LocationContext
